module.exports = "/images/role-manager-icon.svg?d98d49b7eb2cb3fdec4ae38735e06329";